module.exports = {
  ADD_ITEM: Symbol("ADD_ITEM"),
  REMOVE_ITEM: Symbol("REMOVE_ITEM"),
  SET: Symbol("SET"),
  DEL: Symbol("DEL")
};



// WEBPACK FOOTER //
// ./src/js/constants/TransactionTypes.js